var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNonFood = function SvgNonFood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17.765v-8.53c0-.594-.299-1.148-.795-1.473l-1.907-1.25h-2.703l-1.907 1.25c-.496.325-.795.88-.795 1.474V21H21.5v-3.235z",
    fill: "url(#Non-food_svg__paint0_linear_1120_205240)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.393 10.799H21.5v4.748h-8.107V10.8z",
    fill: "url(#Non-food_svg__paint1_linear_1120_205240)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.705 7.762l-1.908-1.25h-1.324l1.907 1.25c.496.325.795.88.795 1.474V21H21.5V9.235c0-.594-.3-1.148-.795-1.473z",
    fill: "url(#Non-food_svg__paint2_linear_1120_205240)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.671 4.27H4.605V1.629c0-.347.281-.628.627-.628h1.813c.346 0 .626.281.626.628v2.643z",
    fill: "url(#Non-food_svg__paint3_linear_1120_205240)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.045 1H5.44c.346 0 .627.281.627.628v2.643h1.605V1.628A.628.628 0 007.045 1z",
    fill: "url(#Non-food_svg__paint4_linear_1120_205240)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.191 5.824c-.399-.361-.918-.561-1.456-.561H4.45c-.625 0-1.132.508-1.132 1.135v13.62a.98.98 0 00.98.982h10.14c.542 0 .98-.44.98-.981v-.163c0-5.35-2.263-10.45-6.227-14.032zm1.944 6.248a.772.772 0 01-.72-.403A12.237 12.237 0 008.212 8.76a.775.775 0 01-.203-.77l.004-.014a.773.773 0 011.303-.319c.941.99 1.76 2.08 2.442 3.245a.776.776 0 01-.623 1.168z",
    fill: "url(#Non-food_svg__paint5_linear_1120_205240)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.191 5.824c-.399-.361-.918-.561-1.455-.561H6.41c.538 0 1.057.2 1.456.56a18.915 18.915 0 016.227 14.033v.163a.98.98 0 01-.98.981h1.325c.54 0 .979-.44.979-.981v-.163c0-5.35-2.263-10.45-6.227-14.032z",
    fill: "url(#Non-food_svg__paint6_linear_1120_205240)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.012 3.827h4.252v1.435H4.012V3.827z",
    fill: "url(#Non-food_svg__paint7_linear_1120_205240)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.646 7.004c.555 0 1.005.451 1.005 1.008v.973c0 .206.064.408.181.577l2.576 3.703c.188.27.495.431.824.431h1.854c.436 0 .823.282.956.698.274.852.705 2.366.865 3.876a1.006 1.006 0 01-1 1.11h-7.26a1.007 1.007 0 01-1.006-1.007V8.012c0-.557.45-1.008 1.005-1.008z",
    fill: "url(#Non-food_svg__paint8_linear_1120_205240)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.779 6.514h-2.664v-2c0-.384.311-.697.696-.697h1.272c.384 0 .696.313.696.698v1.999z",
    fill: "url(#Non-food_svg__paint9_linear_1120_205240)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.082 3.817H16.81l-.026.002c.372.014.67.32.67.696v1.999h1.324v-2a.697.697 0 00-.696-.697z",
    fill: "url(#Non-food_svg__paint10_linear_1120_205240)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Non-food_svg__paint0_linear_1120_205240",
    x1: 17.446,
    y1: 6.513,
    x2: 17.446,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D3E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Non-food_svg__paint1_linear_1120_205240",
    x1: 18.215,
    y1: 10.76,
    x2: 17.417,
    y2: 15.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BBAF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Non-food_svg__paint2_linear_1120_205240",
    x1: 16.918,
    y1: 2.486,
    x2: 25.128,
    y2: 5.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopOpacity: 0.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Non-food_svg__paint3_linear_1120_205240",
    x1: 5.545,
    y1: 4.197,
    x2: 6.19,
    y2: 0.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DB159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBF68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Non-food_svg__paint4_linear_1120_205240",
    x1: 5.132,
    y1: 0.091,
    x2: 7.915,
    y2: 2.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopOpacity: 0.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Non-food_svg__paint5_linear_1120_205240",
    x1: 12.385,
    y1: 23.046,
    x2: 2.765,
    y2: 0.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D99F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0FFDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Non-food_svg__paint6_linear_1120_205240",
    x1: 6.718,
    y1: 0.773,
    x2: 26.318,
    y2: 15.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopOpacity: 0.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Non-food_svg__paint7_linear_1120_205240",
    x1: 6.519,
    y1: 5.3,
    x2: 6.517,
    y2: 3.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D8F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98C25C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Non-food_svg__paint8_linear_1120_205240",
    x1: 7.481,
    y1: 19.102,
    x2: 4.635,
    y2: 4.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DB159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBF68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Non-food_svg__paint9_linear_1120_205240",
    x1: 17.699,
    y1: 3.795,
    x2: 16.953,
    y2: 6.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BBAF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Non-food_svg__paint10_linear_1120_205240",
    x1: 16.936,
    y1: 4.238,
    x2: 18.712,
    y2: 5.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529DE2"
  })))));
};
export default __webpack_public_path__ + "static/media/Non-food.d97ebb94.svg";
export { SvgNonFood as ReactComponent };